export function wrapperToggleUpdate(e) {
	// console.log(e)
	const target = e.target
	const el = document.getElementById(target)
	// console.log(target, el)
	if ( el ) {
		el.style.opacity = 0
		el.classList.add('active');
		
		// $(`#${target}`).addClass('active')
		// console.log($(`#${target}`))
		// $($a.attr('data-target')).css('opacity', 0).addClass('active')
		
		// $('.vw-component').removeClass('active')
		// Array.from(document.getElementsByClassName('vw-component')).forEach( item => {
		// 	item.classList.remove('active')
		// })
        setTimeout(function(){
        //     // $(window).trigger('resize')
            window.dispatchEvent(new Event('resize'))
            setTimeout(function(){
                el.style.opacity = 1
                // $(`#${target}`).css('opacity', 1)
            }, 300)
        }, 500)
    }
}


export const headlessModuleSessionVerify = async(result) => {
    // $.ajax({
    //     url: BRYTER.ajaxUrl,
    //     data: {
    //         action: 'headlessModuleSessionVerify',
    //         params: result,
    //         env: BRYTER.envId,
    //     },

    //     success: function( html ) {
    //         // console.log(html)
    //     }
    // })

    
    return async (dispatch) => {
    	const data = {
	        action: 'headlessModuleSessionVerify',
	        params: result,
	        env: BRYTER.envId
	    }
	    const response = await fetch(BRYTER.ajaxUrl, {
			method: 'POST',
			headers: {
			// 'Content-Type': 'application/json'
			},
			body: JSON.stringify(data)
		})

		dispatch({response});
	}
}